export const ChevronUp = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.63525 20.6488L16.0454 11.3512L25.3648 20.6153" stroke="currentColor" stroke-width="2"/>
</svg>`;
